import { Injectable } from '@angular/core';
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class StyleLoaderService {

    /**
     * Dynamically loads a stylesheet by creating a <link> tag and returns an Observable.
     * @param id Unique identifier for the stylesheet.
     * @param href Path to the CSS file (e.g., 'assets/styles/third-party.css')
     * @returns Observable<void> that emits when the style is loaded or errors if it fails.
     */
    loadStyle(id: string, href: string): Observable<void> {
        return new Observable<void>((observer) => {
            if (document.getElementById(id)) {
                observer.next(); // Already loaded
                observer.complete();
                return;
            }

            const linkEl = document.createElement('link');
            linkEl.id = id;
            linkEl.rel = 'stylesheet';
            linkEl.href = href;

            linkEl.onload = () => {
                observer.next();
                observer.complete();
            };

            linkEl.onerror = (error) => {
                observer.error(`Failed to load style: ${href}`);
            };

            document.head.appendChild(linkEl);
        });

    }

    /**
     * Removes a dynamically added stylesheet by ID.
     * @param id The ID used when loading the style.
     */
    removeStyle(id: string): void {
        const linkEl = document.getElementById(id);
        if (linkEl) {
            document.head.removeChild(linkEl);
        }
    }
}

